import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { finalize } from 'rxjs/operators';

import { ApiService } from '@services/api.service';
import { CoreService } from '../core.service';
import { LoggingService } from '@services/logging.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'hss-contact',
    templateUrl: 'contact.component.html'
})

export class ContactComponent implements OnInit {
    name: string;
    email: string;
    subject: string;
    message: string;
    //
    isSubmitting = false;
    //
    feedbackClass: string;
    feedbackMessage: string;
    feedbackVisible = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private apiService: ApiService,
        private coreService: CoreService,
        private logger: LoggingService,
        public translate: TranslateService
    ) {}


    // ----  LIFECYCLE:
    ngOnInit(): void {}

    onSubmitContact(): void {
        let field;
        let feedback = '';
        this.feedbackVisible = false;
        this.feedbackMessage = '';
        event.preventDefault();
        //  Per-field Input Validation:
        if (!this.name) {
            field = this.translate.instant('STRING.NAME');
            feedback += '<span>' + this.translate.instant('FEEDBACK.NOT_FILLED_IN', {'field': field}) + '</span>';
            this.feedbackVisible = true;
        }
        if (!this.email) {
            field = this.translate.instant('STRING.EMAIL');
            feedback += '<span>' + this.translate.instant('FEEDBACK.NOT_FILLED_IN', {'field': field}) + '</span>';
            this.feedbackVisible = true;
        }
        if (!this.subject) {
            field = this.translate.instant('STRING.SUBJECT');
            feedback += '<span>' + this.translate.instant('FEEDBACK.NOT_FILLED_IN', {'field': field}) + '</span>';
            this.feedbackVisible = true;
        }
        if (!this.message) {
            field = this.translate.instant('STRING.MESSAGE');
            feedback += '<span>' + this.translate.instant('FEEDBACK.NOT_FILLED_IN', { 'field': field }) + '</span>';
            this.feedbackVisible = true;
        }
        //
        if (this.feedbackVisible) {
            this.feedbackClass = 'error';
            this.feedbackMessage = feedback;
        } else {
            this.doSubmitContact();
        }
    }

    doSubmitContact(): void {
        let postData = {
            name: this.name,
            email: this.email,
            subject: this.subject,
            message: this.message
        };
        //  Request:
        this.isSubmitting = true;
        let contactObservable = this.coreService.submitContact(postData);
        contactObservable
            .pipe(finalize(() =>
                setTimeout(() => {
                    this.isSubmitting = false;
                }, 500)
            ))
            .subscribe(
                (response) => {
                    this.logger.print('Submit Contact succeeded', response, 'log');
                    this.feedbackClass = 'success';
                    this.feedbackMessage = '<span>' + this.translate.instant('STRING.CONTACT.SUBMIT.SUCCESS') + '</span>';
                    this.feedbackVisible = true;
                    //  Clear form:
                    this.name = '';
                    this.email = '';
                    this.subject = '';
                    this.message = '';
                },
                (error) => {
                    this.logger.print('Submit Contact failed', error, 'error');
                    if (error.status) {
                        this.feedbackMessage = '<span>' + this.translate.instant('STRING.CONTACT.SUBMIT.ERROR.CODE', {error: error.status}) + '</span>';
                    } else {
                        this.feedbackMessage = '<span>' + this.translate.instant('STRING.CONTACT.SUBMIT.ERROR.UNKNOWN') + '</span>';
                    }
                    this.feedbackClass = 'error';
                    this.feedbackVisible = true;
                },
                () => {}
            );
    }

    navigate(route): void {
        this.router.navigate([route]);
    }
}
